import { render, staticRenderFns } from "./SpendComparisonMini.vue?vue&type=template&id=66e52b9b"
import script from "./SpendComparisonMini.vue?vue&type=script&lang=js"
export * from "./SpendComparisonMini.vue?vue&type=script&lang=js"
import style0 from "./SpendComparisonMini.vue?vue&type=style&index=0&id=66e52b9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports